export default "__VITE_ASSET__Cgz$6RdG__"